<template>
    <div >
      <b-modal v-if="false"
        id="medicationLabelsRep" 
        size="md" 
        centered 
        :title="$t('Shared.Printmedlabels')"
        :ok-title="$t('Shared.Print')" 
        :cancel-title="$t('Shared.Preview')"
        :visible="true"
        :no-close-on-backdrop="true" 
        @ok="onPrint" 
        @cancel="onPreview">
        <b-row>
          <b-col lg="6" md="6" sm="6">
            
          </b-col>
          <b-col lg="6" md="6" sm="6">
            
          </b-col>
        </b-row>
      </b-modal>

      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="$t('Shared.Printmedlabels')"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
        :wrapper-attr="popupAttributes"
      >
        <ReportViewer
          ref="medicationLabelsRep"
          :ReportName="'LabelsReport'"
          :ReportTitle="$t('Shared.Printmedlabels')"
          :IsAnAPIReport="true"
        />
    </DxPopup>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { DxPopup } from 'devextreme-vue/popup';
    import ShowMessage from '@/components/messages/ShowMessage.js'

    export default Vue.extend({
        name: "MedicationLabelsRep",
        mixins: [ ShowMessage ],
        components: { DxPopup },
        props: {
          closeWindow: Function,
          codeList: Array,
        },
        data() {
            return {
                isParamVisible: true,
                isReportVisible: false,
                reportParams: [],
                popupAttributes: {
                  id: 'modalmedicationLabelsRep'
                },
                doPrint: true
            }
        },
        methods: {

            onShowing(e) {
              let contentElement = e.component.content();
              let titleElement = e.component._$title[0]
              contentElement.style.padding = '0px';
              titleElement.style.padding = '0px 20px'
            },

            onHiddenReport() {
              this.isReportVisible = false
              this.closeWindow()
            },

            onClickClose() {
              //this.closeWindow()
              this.isParamVisible = false;
            },

            async onClickShowReport() {
              this.isParamVisible = false

              this.reportParams = []
              
              this.reportParams.push({ paramName: 'codeList', paramValue: this.codeList})
              this.reportParams.push({ paramName: 'code', paramValue: 'MEDLABEL'})
              this.reportParams.push({ paramName: 'doPrint', paramValue: this.doPrint})

              this.isReportVisible = true

              await this.$refs.medicationLabelsRep.buildDocument(this.reportParams)
            },
            
            onPreview() {
              this.onClickShowReport()
            },

            async onPrint(){
              //this.closeWindow()
            }
        },
        
        mounted () {
          this.onClickShowReport()
        },
    })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
